import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

const ordinals: string[] = ['th','st','nd','rd'];

@Pipe({
  name: 'dateSuffix',
  pure: true
})
export class DateSuffixPipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe
  ) {}

  transform(date: string): string {
    let dt = parseInt(this.datePipe.transform(date, 'd'));
    let v = dt%100;
    return dt+(ordinals[(v-20)%10] || ordinals[v] || ordinals[0]);
  }

}
